import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import D1 from "../../components/ExcerciseTypes/Design/TypeIn";

const json = {
  1: { // Exercise num
    unit: "Unit 11",
    id: "SB3-U11-P79-E1",
    audio: "img/FriendsPlus/Page79/Audio/audio-e1-p79.mp3",
    video: "",
    component: T6,
    stylesTextInput: { borderBottomWidth: 0, backgroundColor: 'transparent' },
    exerciseKey: "img/FriendsPlus/Page79/E1/Key/answerKey.png",
    inputSize: 34,
    maxLength: 1,
    padding: 0,
    textAlign: 'center',
    titleImage: "",
    titleQuestion: [
      {
        color: "#44509f", num: "1",
        title: 'Listen and number. <headphone name="125" src="img/FriendsPlus/Page79/Audio/tieude-e1-p79.mp3"></headphone>',
      },
    ],
    questionImage: [],
    questions: [
      {
        title: `
          <div style='display: flex; flex-direction: row;position: relative;'>
            <img src="img/FriendsPlus/Page79/E1/1.jpg" style="width: 110%">
            <div style=" position: absolute; top: 304px; left: 133px; "><input id='0' /></div>
            <div style=" position: absolute; top: 304px; left: 445px; "><input id='1' /></div>
            <div style=" position: absolute; top: 304px; left: 602px; "><input id='2' /></div>
            <div style=" position: absolute; top: 304px; left: 759px; "><input id='3' /></div>
          </div>
        `,
        answer: ['5', '3', '2', '4'],
      },
    ],
  },
  2: { // Exercise num
    unit: 'Unit 11',
    id: 'SB3-U11-P79-E2',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page79/E2/1.jpg' }]],
  },
  3: { // Exercise num
    unit: 'Unit 11',
    id: 'SB3-U11-P79-E3',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: '',
    isAllowSubmit: false,
    hideBtnFooter: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page79/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page79/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page79/E3/3.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page79/E3/5.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E3/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page79/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page79/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page79/E3/9.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E3/10.jpg' },
        { url: 'img/FriendsPlus/Page79/E3/11.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E3/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page79/E3/13.jpg' },
      ],
    ],
  },
  4: { // Exercise num
    unit: 'Unit 11',
    id: 'SB3-U11-P79-E4',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: '',
    isAllowSubmit: false,
    hideBtnFooter: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page79/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page79/E4/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page79/E4/3.jpg' },
        { url: 'img/FriendsPlus/Page79/E4/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E4/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page79/E4/6.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page79/E4/7.jpg' },
        { url: 'img/FriendsPlus/Page79/E4/8.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E4/9.jpg' },
      ],
    ],
  },
}

export default json;